export default __webpack_public_path__ + "static/media/screenshot2.6a360bcf.jpg";